import React, { InputHTMLAttributes } from "react";
import styles from "./CustomInputField.module.css";
import Tooltip, { TooltipProps } from "../Tooltip/Tooltip";
import InputErrorMessage from "../InputErrorMessage";

interface InputFieldProps
  extends InputHTMLAttributes<HTMLInputElement>, TooltipProps {
  errorMessage?: string;
  label?: string;
}

const CustomInputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
  ({ label, errorMessage, info, className, ...rest }, ref) => {
    return (
      <label
        className={`${styles.inputWrapper} ${className}`}
        htmlFor={rest.name}
      >
        {label && (
          <span className={styles.inputLabel}>
            {label}{" "}
            {rest.required && <strong className="text-danger">*</strong>}
          </span>
        )}

        <input
          className={`${styles.inputField} ${rest.disabled ? "disabled" : ""}`}
          id={rest.name || rest.id}
          ref={ref}
          {...rest}
        />
        <InputErrorMessage errorMessage={errorMessage} />
        {info && <Tooltip info={info} extraClassName={styles.inputTooltip} />}
      </label>
    );
  },
);

CustomInputField.displayName = "CustomInputField"; // 👈 avoids React devtools warning

export default CustomInputField;
